import {Howl, Howler} from "howler";
import * as PIXI from "pixi.js";
import {ButtonState} from "./ButtonState";

export class CheckBox extends PIXI.Sprite {

    protected uncheckedBaseTexture: PIXI.Texture;
    protected uncheckedOnHoverTexture: PIXI.Texture;
    protected uncheckedOnClickTexture: PIXI.Texture;
    protected uncheckedInactiveTexture: PIXI.Texture;
    protected checkedBaseTexture: PIXI.Texture;
    protected checkedOnHoverTexture: PIXI.Texture;
    protected checkedOnClickTexture: PIXI.Texture;
    protected checkedInactiveTexture: PIXI.Texture;

    private onClickedSubscribers: Array<Function> = [];
    private sound: Howl;
    private isChecked = false;
    private _enabled: boolean = true;

    private readonly DEFAULT_ANCHOR_POINT: any = new PIXI.Point(0.5, 0.5);

    constructor(uncheckedTexturePath: string, uncheckedOnHoverTexturePath: string, uncheckedOnClickTexturePath: string,
                uncheckedInactiveTexturePath: string, checkedTexturePath: string, checkedOnHoverTexturePath: string,
                checkedOnClickTexturePath: string, checkedInactiveTexturePath: string, soundNamePath: string) {
        super(PIXI.Texture.fromFrame(uncheckedTexturePath));
        this.uncheckedBaseTexture = PIXI.Texture.fromFrame(uncheckedTexturePath);
        this.uncheckedOnHoverTexture = PIXI.Texture.fromFrame(uncheckedOnHoverTexturePath);
        this.uncheckedOnClickTexture = PIXI.Texture.fromFrame(uncheckedOnClickTexturePath);
        this.uncheckedInactiveTexture = PIXI.Texture.fromFrame(uncheckedInactiveTexturePath);
        this.checkedBaseTexture = PIXI.Texture.fromFrame(checkedTexturePath);
        this.checkedOnHoverTexture = PIXI.Texture.fromFrame(checkedOnHoverTexturePath);
        this.checkedOnClickTexture = PIXI.Texture.fromFrame(checkedOnClickTexturePath);
        this.checkedInactiveTexture = PIXI.Texture.fromFrame(checkedInactiveTexturePath);
        this.interactive = true;
        this.buttonMode = true;
        this.anchor = this.DEFAULT_ANCHOR_POINT;
        this.addOnMouseDownLister();
        this.addMouseOverListener();

        this.sound = new Howl({
            src: [soundNamePath],
        });
    }

    public get checked(): boolean {
        return this.isChecked;
    }

    public set checked(value: boolean) {
        this.isChecked = value;
        this.changeSprite();
    }

    get enabled(): boolean {
        return this._enabled;
    }

    set enabled(value: boolean) {
        this._enabled = value;
        if (this._enabled) {
            if (this.isChecked) {
                this.texture = this.checkedBaseTexture;
            } else {
                this.texture = this.uncheckedBaseTexture;
            }
        } else {
            if (this.isChecked) {
                this.texture = this.checkedInactiveTexture;
            } else {
                this.texture = this.uncheckedInactiveTexture;
            }
        }
    }

    public subscribeOnClicked(subscriber: Function): void {
        this.onClickedSubscribers.push(subscriber);
    }

    private clickListener(): void {
        this.isChecked = !this.isChecked;
        this.changeSprite();
        this.sound.play();
        this.callAllSubscribers();
    }

    private changeSprite(): void {
        if (this.isChecked) {
            if (this._enabled) {
                this.texture = this.checkedBaseTexture;
            } else {
                this.texture = this.checkedInactiveTexture;
            }
        } else {
            if (this._enabled) {
                this.texture = this.uncheckedBaseTexture;
            } else {
                this.texture = this.uncheckedInactiveTexture;
            }
        }
    }

    private addOnMouseDownLister(): void {
        this.on("pointerdown", () => {
            if (this._enabled) {
                this.clickListener();
                if (this.isChecked) {
                    this.texture = this.checkedOnClickTexture;
                } else {
                    this.texture = this.uncheckedOnClickTexture;
                }
            }
        });
        this.on("pointerup", () => {
            if (this._enabled) {
                if (this.isChecked) {
                    this.texture = this.checkedOnHoverTexture;
                } else {
                    this.texture = this.uncheckedOnHoverTexture;
                }
            }
        });
        this.on("pointercancel", () => {
            if (this._enabled) {
                if (this.isChecked) {
                    this.texture = this.checkedBaseTexture;
                } else {
                    this.texture = this.uncheckedBaseTexture;
                }
            }
        });
        this.on("pointerupoutside", () => {
            if (this._enabled) {
                if (this.isChecked) {
                    this.texture = this.checkedBaseTexture;
                } else {
                    this.texture = this.uncheckedBaseTexture;
                }
            }
        });
    }

    private addMouseOverListener(): void {
        this.on("pointerover", () => {
            if (this._enabled) {
                if (this.isChecked) {
                    this.texture = this.checkedOnHoverTexture;
                } else {
                    this.texture = this.uncheckedOnHoverTexture;
                }
            }
        });
        this.on("pointerout", () => {
            if (this._enabled) {
                if (this.isChecked) {
                    this.texture = this.checkedBaseTexture;
                } else {
                    this.texture = this.uncheckedBaseTexture;
                }
            }
        });
    }

    private callAllSubscribers(): void {
        for (let i = 0; i < this.onClickedSubscribers.length; i++) {
            this.onClickedSubscribers[i](this.isChecked);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/controlElements/CheckBox.ts